import { useGetMetadocOptionsQuery } from "services/metadoc-api";

/**
 * hook to fetch metadoc document type options from the API
 * returns empty array if API fails or is loading
 */
export const useMetadocOptions = () => {
  const { data, isLoading, error } = useGetMetadocOptionsQuery();

  // if API data is available, use it
  if (data && data.length > 0) {
    const getColor = (documentType: string): string => {
      const option = data.find((opt) => opt.document_type === documentType);
      return option?.color || "#8e44ad"; // default to amethyst purple
    };

    const getShortcut = (documentType: string): string | undefined => {
      const option = data.find((opt) => opt.document_type === documentType);
      return option?.shortcut;
    };

    return {
      options: data,
      getDocumentTypeColor: getColor,
      getDocumentTypeShortcut: getShortcut,
      isLoading,
      error,
    };
  }

  // return empty array if API fails or is loading
  return {
    options: [],
    getDocumentTypeColor: () => "#8e44ad",
    getDocumentTypeShortcut: () => undefined,
    isLoading,
    error,
  };
};
